@if (selectedNode) {
    <div>
        <div>
            <div class="d-flex justify-content-between w-100 align-items-center header">
                <h4 class="ttl">
                    {{ selectedNode?.endPointName }}
                </h4>
                <div>
                    <img class="wifi-img" alt="wifi" src="assets/images/wifi.svg" [title]="getSignalStrengthTitle()">
                    <span class="battery-percentage">
                        @if (batteryInfo.imgSrc) {
                            <img class="battery-img" [src]="batteryInfo.imgSrc"
                                [title]="batteryInfo.tooltip">
                        }
                        <span>{{ batteryInfo.percentage }}</span>
                    </span>
                </div>
            </div>
            <hr />

            <div class="modal-body">
                @if (selectedNode?.timestamp) {
                    <div class="reported-date d-flex justify-content-between align-items-center">
                        <span class="reported-label">{{'Last Reported' | translate}}</span>
                        <span class="reported-time">
                            <span class="time">{{ selectedNode?.formattedTime }}</span> <span class="bullet">•</span> {{
                            selectedNode?.formattedDate }}
                        </span>
                    </div>
                }

                <div class="card-inner-main-div">
                    @if (loadingDetails) {
                        <app-rings-loader></app-rings-loader>
                    }

                    <div class="row" [class.hidden-div]="loadingDetails">
                        <div class="col-12">
                            <div (resized)="onResized($event)">
                                <div [id]="CHART_DIV_ID" class="chart-section" [class.hidden]="chartHasNoData"></div>
                                @if (chartHasNoData) {
                                    <div class="no-data clickable-no-data" (click)="goToNodeDetails()">
                                        {{'No Data Found' | translate}}
                                        <small>{{'Click to view node details' | translate}}</small>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                    @if (!chartHasNoData && !loadingDetails) {
                        <a class="main-btn details-btn border-btn mt-4 w-100"
                            (click)="goToNodeDetails()">
                            {{'More Details' | translate}}
                        </a>
                    }
                </div>
            </div>
        </div>
    </div>
}
